// ======================================================================
// File: src/modules/ipe/costing/CostingOverlayDrawer.js
// ======================================================================


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ipeCostingService from "../services/ipeCostingService";
import "./costing.css";
import CostingFullScreenDrawer from  "./components/CostingFullScreenDrawer";
export default function CostingOverlayDrawer({ enquiryId, onClose }) {

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [overhead, setOverhead] = useState("");
    const [transport, setTransport] = useState("");
    const [packing, setPacking] = useState("");
    const [insurance, setInsurance] = useState("");
    const [margin, setMargin] = useState("");
    const [tax, setTax] = useState("");
    const [showFullView, setShowFullView] = useState(false);

  useEffect(() => {

    async function load() {

      try {

        const res = await ipeCostingService.getCostDashboard(enquiryId);

        setData(res || null);

        if (res?.items?.length > 0) {
          setSelectedItemId(res.items[0].id);
        }

      } finally {

        setLoading(false);

      }

    }

    load();

  }, [enquiryId]);


  // --------------------------------------------------
  // GENERATE COST
  // --------------------------------------------------

  const generateCost = async () => {

    await ipeCostingService.generateCost(enquiryId);

    const res = await ipeCostingService.getCostDashboard(enquiryId);

    setData(res || null);

  };


  // --------------------------------------------------
  // RECALCULATE COST
  // --------------------------------------------------

  const recalcCost = async () => {

    try {

      await ipeCostingService.regenerateCost(enquiryId);

      alert("New costing version created");

      const res = await ipeCostingService.getCostDashboard(enquiryId);

      setData(res || null);

      if (res?.items?.length > 0) {
        setSelectedItemId(res.items[0].id);
      }

    } catch (err) {

      alert(err?.response?.data?.message || "Recalculation failed");

    }

  };


  const summary = data?.summary || {};
  const items = data?.items || [];
  const materials = data?.materials || [];
  const operations = data?.operations || [];
  const pricingEditable = summary.status === "draft";

  useEffect(() => {

    if (!data) return;

    const s = data.summary || {};

    setOverhead(s.overhead_percent ?? "");
    setTransport(s.transport_charge ?? "");
    setPacking(s.packing_charge ?? "");
    setInsurance(s.insurance_charge ?? "");
    setMargin(s.margin_percent ?? "");
    setTax(s.tax_percent ?? "");

  }, [data]);

  if (loading) return null;
  

  
  // --------------------------------------------------
  // FILTER BREAKDOWN BY SELECTED ITEM
  // --------------------------------------------------

  const filteredMaterials = materials.filter(
    (m) => m.cost_item_id === selectedItemId
  );

  const filteredOperations = operations.filter(
    (o) => o.cost_item_id === selectedItemId
  );

  const applyPricing = async () => {

    try {

        const payload = {
        overhead_percent: Number(overhead || 0),
        transport_charge: Number(transport || 0),
        packing_charge: Number(packing || 0),
        insurance_charge: Number(insurance || 0),
        margin_percent: Number(margin || 0),
        tax_percent: Number(tax || 0)
        };

        await ipeCostingService.applyPricing(enquiryId, payload);

        const res = await ipeCostingService.getCostDashboard(enquiryId);

        setData(res || null);

    } catch (err) {

        console.error("Pricing failed", err);

    }

    };

  const submitCost = async () => {

    await ipeCostingService.submitCost(enquiryId);

    const res = await ipeCostingService.getCostDashboard(enquiryId);

    setData(res || null);

  };

  const approveCost = async () => {

    await ipeCostingService.approveCost(enquiryId);

    const res = await ipeCostingService.getCostDashboard(enquiryId);

    setData(res || null);

  };

  const rejectCost = async () => {

    await ipeCostingService.rejectCost(enquiryId);

    const res = await ipeCostingService.getCostDashboard(enquiryId);

    setData(res || null);

  };  
  return (

    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: "90%",
        height: "100%",
        background: "#fff",
        boxShadow: "-4px 0 12px rgba(0,0,0,0.15)",
        zIndex: 2000,
        overflowY: "auto",
        padding: 24,
      }}
    >

      {/* HEADER */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          flexWrap: "wrap"
        }}
      >

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

          <div style={{ fontSize: 20, fontWeight: 700 }}>
            Engineering Costing
          </div>

          {summary.version_no && (
            <span className="badge bg-primary">
              Version {summary.version_no}
            </span>
          )}

          {summary.status && (
            <span
              className={`badge ${
                summary.status === "draft"
                  ? "bg-secondary"
                  : summary.status === "submitted"
                  ? "bg-warning text-dark"
                  : summary.status === "approved"
                  ? "bg-success"
                  : "bg-danger"
              }`}
            >
              {summary.status.toUpperCase()}
            </span>
          )}

        </div>

        <div style={{ display: "flex", gap: 10 }}>

          {/* NO COST YET */}
          {!data && (
            <button
              className="btn btn-success"
              onClick={generateCost}
            >
              Generate Cost
            </button>
          )}

          {/* DRAFT */}
          {summary.status === "draft" && (
            <>
              <button
                className="btn btn-success"
                onClick={generateCost}
              >
                Generate Cost
              </button>

              <button
                className="btn btn-warning"
                onClick={recalcCost}
              >
                Recalculate
              </button>

              <button
                className="btn btn-primary"
                onClick={submitCost}
              >
                Submit
              </button>
            </>
          )}

          {/* SUBMITTED */}
          {summary.status === "submitted" && (
            <>
              <button
                className="btn btn-success"
                onClick={approveCost}
              >
                Approve
              </button>

              <button
                className="btn btn-danger"
                onClick={rejectCost}
              >
                Reject
              </button>
            </>
          )}

          {/* REJECTED */}
          {summary.status === "rejected" && (
            <button
              className="btn btn-warning"
              onClick={recalcCost}
            >
              Recalculate
            </button>
          )}
          <button
            className="btn btn-outline-primary"
            onClick={() => setShowFullView(true)}
          >
            View Cost Sheet
          </button>

          <button
            onClick={onClose}
            className="btn btn-outline-secondary"
          >
            Close
          </button>

        </div>



      </div>


      {/* COST SUMMARY */}

      <div className="card mb-4">
        <div className="card-body">

          <h5>Cost Summary</h5>

          <div className="row g-3">

            {[
              ["Material Cost", summary.material_cost],
              ["Machine Cost", summary.machine_cost],
              ["Labour Cost", summary.labour_cost],
              ["Manufacturing Cost", summary.manufacturing_cost],
              ["Margin", summary.margin_amount],
              ["Selling Price", summary.selling_price],
              ["Final Price", summary.final_price],
            ].map(([label, value], idx) => (

              <div className="col-md-3" key={idx}>
                <div className="card text-center border-primary">
                  <div className="card-body">
                    <small>{label}</small>
                    <h5>{value || 0}</h5>
                  </div>
                </div>
              </div>

            ))}

          </div>

        </div>
      </div>


      {/* ITEMS + PRICING PANEL */}

      <div className="row">

        {/* ITEMS */}

        <div className="col-md-8">

          <div className="card mb-4">
            <div className="card-body">

              <h5>Item Cost</h5>

              <table className="table table-bordered">

                <thead>

                  <tr>
                    <th>Item</th>
                    <th>Product</th>
                    <th>Equipment</th> {/* Added */}
                    <th>Qty</th>
                    <th>Material</th>
                    <th>Machine</th>
                    <th>Labour</th>
                    <th>Total</th>
                  </tr>

                </thead>

                <tbody>

                  {items.map((i, idx) => (

                    //

                    <tr
                      key={idx}
                      onClick={() => setSelectedItemId(i.id)}
                      className={selectedItemId === i.id ? "cost-row-selected" : ""}
                      style={{ cursor: "pointer" }}
                    > 


                    <td>{i.item_seq_no}</td>
                      <td>{i.product_variant_name || "-"}</td>
                      <td>{i.equipment_name || "-"}</td> {/* Added */}
                      <td>{i.quantity}</td>

                      <td>{i.material_cost}</td>
                      <td>{i.machine_cost}</td>
                      <td>{i.labour_cost}</td>

                      <td>{i.total_cost}</td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>
          </div>

        </div>


        {/* PRICING PANEL */}

        <div className="col-md-4">

          <div className="card mb-4">

            <div className="card-body">

              <h5>Pricing</h5>

              <div className="mb-2">
                <label>Overhead %</label>
                
                <input
                  className="form-control"
                  value={overhead}
                  disabled={!pricingEditable}
                  onChange={(e) => setOverhead(e.target.value)}
                />
              </div>

              <div className="mb-2">
                <label>Transport</label>
                <input
                    className="form-control"
                    value={transport}
                    disabled={!pricingEditable}
                    onChange={(e) => setTransport(e.target.value)}
                    />
              </div>

              <div className="mb-2">
                <label>Packing</label>
                <input
                    className="form-control"
                    value={packing}
                    disabled={!pricingEditable}
                    onChange={(e) => setPacking(e.target.value)}
                    />
              </div>

              <div className="mb-2">
                <label>Insurance</label>
                <input
                    className="form-control"
                    value={insurance}
                    disabled={!pricingEditable}
                    onChange={(e) => setInsurance(e.target.value)}
                    />
              </div>

              <div className="mb-2">
                <label>Margin %</label>
                <input
                    className="form-control"
                    value={margin}
                    disabled={!pricingEditable}
                    onChange={(e) => setMargin(e.target.value)}
                    />
              </div>

              <div className="mb-3">
                <label>Tax %</label>
                <input
                    className="form-control"
                    value={tax}
                    disabled={!pricingEditable}
                    onChange={(e) => setTax(e.target.value)}
                    />
              </div>

              <button
                className="btn btn-primary w-100"
                onClick={applyPricing}
                disabled={!pricingEditable}
                >
                Apply Pricing
                </button>

            </div>

          </div>

        </div>

      </div>


      {/* MATERIAL + OPERATION BREAKDOWN */}

      <div className="row">

        <div className="col-md-6">

          <div className="card mb-4">

            <div className="card-body">

              <h5>Material Breakdown</h5>

              <table className="table table-bordered">

                <thead>
                  <tr>
                    <th>Material</th>
                    <th>Qty</th>
                    <th>Unit Cost</th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>

                  {filteredMaterials.map((m, idx) => (

                    <tr key={idx}>

                      <td>{m.material_name || m.description || "-"}</td>
                      <td>{m.quantity}</td>
                      <td>{m.unit_cost}</td>
                      <td>{m.total_cost}</td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </div>


        <div className="col-md-6">

          <div className="card mb-4">

            <div className="card-body">

              <h5>Operation Breakdown</h5>

              <table className="table table-bordered">

                <thead>

                  <tr>
                    <th>Operation</th>
                    <th>Setup</th>
                    <th>Run</th>
                    <th>Machine</th>
                    <th>Labour</th>
                    <th>Total</th>
                  </tr>

                </thead>

                <tbody>

                  {filteredOperations.map((o, idx) => (

                    <tr key={idx}>

                      <td>{o.operation_name || o.description || "-"}</td>
                      <td>{o.setup_time}</td>
                      <td>{o.run_time}</td>

                      <td>{o.machine_cost}</td>
                      <td>{o.labour_cost}</td>
                      <td>{o.total_cost}</td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

    {/* FULL SCREEN COST SHEET */}
    {showFullView && (
      <CostingFullScreenDrawer
        enquiryId={enquiryId}
        onClose={() => setShowFullView(false)}
      />
    )}

    </div>

  );

}
